


























































































import Vue from "vue";
import MenuItem from "./MenuItem.vue";
import { SharedState } from "@/common/state/index";
import { computed, ref } from "@vue/composition-api";
import { BackDoor } from "@/backdoor";
export default Vue.extend({
  props: {
    showLogout: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MenuItem,
  },
  setup() {
    const {
      is_not_production,
      paymentEdition,
      isDemo,
      loggedUser,
      toggleTheme,
      theme,
    } = SharedState;
    const editionDisplayName = computed(() => paymentEdition.value.displayName);

    const isNotDemo = computed(() => !isDemo.value);

    const isX2oAdmin = computed(
      () => loggedUser.value.email === "x2oadmin@cognni.ai"
    );

    const changeTheme = () => {
      toggleTheme();
    };

    const did_user_upgraded_all = computed(() =>
      SharedState.pricing_plans.value.every((plan) =>
        SharedState.is_already_upgraded(plan.id)
      )
    );

    const back_door_count = ref(0);

    const change_x_words = () => {
      back_door_count.value++;
      if (back_door_count.value > 10) {
        if (back_door_count.value % 2 === 0) {
          BackDoor.set_x_words_to("biz");
        } else {
          BackDoor.set_x_words_to("user");
        }
      }
    };

    return {
      is_not_production,
      user: SharedState.loggedUser,
      editionDisplayName,
      isNotDemo,
      changeTheme,
      isX2oAdmin,
      theme,
      did_user_upgraded_all,
      change_x_words,
    };
  },
});
